import React, { useContext } from "react";
import PropTypes from "prop-types";
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, getParam, Api, CaseModalState, Loader, getSessionId, useDataProvider, DataContext, Case, DynamicObjectType, saveContentVersion, callApi } from '@cloudpremise/portal_core';
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Box from '@mui/material/Box';
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDModal from "@cloudpremise/portal_core/src/themes/mui/components/MDModal";
import MDSelect from "@cloudpremise/portal_core/src/themes/mui/components/MDSelect";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDAvatar from "@cloudpremise/portal_core/src/themes/mui/components/MDAvatar/InitialAvatar";
import FormWizard from "@cloudpremise/portal_core/src/themes/mui/components/FormWizard";
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import moment from "moment";
import MDTimestamp from "@cloudpremise/portal_core/src/themes/mui/components/MDTimestamp";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";

import Config from "../../../../Config";
const cdnUrl = Config.getCdnUrl();

// Images
const kal = cdnUrl + "/assets/images/kal-visuals-square.jpg";

const CaseModal = (props) => {
    const MAX_FILE_SIZE = 4500000; //Max file size 4.5 MB 
    const CHUNK_SIZE = 750000; //Chunk Max size 750Kb 
    const dataProvider = useContext(DataContext);
    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    let account = null;
    if(isAuthenticated && accounts.length > 0){
        account = accounts[0];
    }
    let defaultState = {
        Id: "",
        Subject: "",
        Description: "",
        Comment: "",
        IsClosed: false,
        modifiedFields: {},
        error: true,
        errorMessage: null,
        loading: false,
        deleteModal: false,
        hasModifiedFields: false,
        verifiedEntity: props.verifiedEntity,
        items: [],
        loadItems: true,
        loadingItems: false,
        item: null,
        closeModal: false,
        saving: false,
        caseRow: null,
        account: account,
        Type: null,
        typeSelection: [{id: '', label: ''}],
        Sub_Type__c: null,
        subTypeSelection: [{id: '', label: ''}],
        fieldSet: null,
        loadFieldSet: false,
        loadingFieldSet: false,

        formType: "form",
        form: [
            {
                heading: null,
                fields: [],
                conditionalStep: false,
                conditionalStepValue: null,
                conditionalField: null,
                conditionalFieldValue: [],
                conditionalSubField: null,
                conditionalSubFieldValue: null
            }
        ],
        openMenu: false,
        currentFormTab: 0,
        currentForm: null,
        dynamicObjectType: null,
        uploadingFiles: false,
        savingComment: false
    };
    if(props.item !== null){
        defaultState = {
            ...defaultState,
            ...props.item,
            item: props.item
        };
    }
    const [state, setState] = React.useReducer((state: CaseModalState, newState: Partial<CaseModalState>) => ({
        ...state,
        ...newState
    }), defaultState);
    React.useEffect(() => {
        if(!state.loadItems || state.Id.length <= 0){
            return;
        }
        getCaseComments();
    });

    const objectType = 'Case';
    const dynamicObjectTypeRecord: DynamicObjectType = {
        sObjectTypeName: 'Case',
        url: "/v1/dynamicobjecttype/"+objectType
    }
    const [loadingForm] = useDataProvider(dynamicObjectTypeRecord, {

    }, false, (data: any) => {
        if(data && Array.isArray(data?.result)){
            if(data.result.length > 0){
                let dynamicObjectType = data.result[0];
                let newState = {dynamicObjectType: dynamicObjectType};
                try{
                    let layout = JSON.parse(dynamicObjectType.layout);
                    if(layout.hasOwnProperty("formType")){
                        newState['formType'] = layout.formType;
                    }
                    if(layout.hasOwnProperty("form")){
                        newState['form'] = layout.form;
                    }
                }catch(e){ }
                setState(newState);
            }
        }
    });

    async function getCaseComments(){
        const { Id, Comment, loading } = state;
        if(loading){
            return;
        }
        const requestData = {
            CommentBody: Comment,
        };
        let headers = {};
        let method = 'GET';
        let route = '/v1/servicedesk/sfcase/'+Id+'/casecomment';
        const object: Case = {
            sObjectTypeName: "CaseComment",
            url: route,
            method: method,
            headers: headers,
            data: requestData
        };

        callApi(dataProvider, object).then(async (response: any) => {
            const result = response.result;
            setState({
                loadItems: false,
                loadingItems: false,
                errorMessage: null,
                items: result
            });
        }).catch((err) => {
            let errorMessage = null;
            if(typeof(err) === "object" && err.hasOwnProperty("error")){
                errorMessage = err.error;
            }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                errorMessage = err.message;
            }
            setState({
                loadItems: false,
                loadingItems: false,
                error: true,
                errorMessage: errorMessage
            });
        });

        setState({
            loadItems: false,
            loadingItems: true,
            errorMessage: null
        });
    }
    function handleChange(event, name){
        const value = event.target.value;
        setState({
            [name]: value,
            hasModifiedFields: true
        });
    }
    async function onSuccess(requestData, files){
        const { Id } = state;
        let headers = {};
        let method = 'POST';
        let route = '/v1/servicedesk/sfcase';
        if(Id !== null && Id.length > 0){
            method = 'POST';
        }

        const object: Case = {
            sObjectTypeName: "Case",
            url: route,
            method: method,
            headers: headers,
            data: requestData
        };

        callApi(dataProvider, object).then(async (response: any) => {
            let result = response.result;
            if(Array.isArray(result)){
                result = result[0];
            }
            await uploadFiles(files, result.Id);
            props.onSuccess(result);
        }).catch((err) => {
            let errorMessage = null;
            if(err.hasOwnProperty("error") && err.error !== null){
                errorMessage = err.error;
            }
            setState({
                loading: false,
                errorMessage: errorMessage
            });
        });

        setState({
            loading: true,
            errorMessage: null
        });
    }

    function toBase64(file){
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    async function uploadFiles(files, recordId){
        if(files === null || typeof(files) === "undefined" || files.length <= 0){
            return null;
        }
        setState({
            uploadingFiles: true,
            loading: true,
        });
        var base64 = 'base64,';
        const contentVersions = [];
        for(let i = 0; i < files.length; i++){
            const file = files[i];
            let fileContents = await toBase64(file);
            if(typeof(fileContents) === "string"){
                var dataStart = fileContents.indexOf(base64) + base64.length;
                fileContents = fileContents.substring(dataStart);
                const contentVersionId = await uploadProcess(file, fileContents, recordId);
                if(contentVersionId !== null){
                    contentVersions.push(contentVersionId);
                }
            }
        }
        return contentVersions;
    }
    function uploadProcess(file, fileContents, recordId) {
        return new Promise(function(resolve, reject){
            if (file.size > MAX_FILE_SIZE) {
                resolve(null);
            }

            // set a default size or startpostiton as 0 
            var startPosition = 0;
            // calculate the end size or endPostion using Math.min() function which is return the min. value   
            var endPosition = Math.min(fileContents.length, startPosition + CHUNK_SIZE);

            // start with the initial chunk, and set the attachId(last parameter)is null in begin
            uploadInChunk(file, fileContents, startPosition, endPosition, '', recordId, (contentVersionId) => {
                resolve(contentVersionId);
            });
        });
        
        
    }
    function uploadInChunk(file, fileContents, startPosition, endPosition, attachId = '', recordId, callback) {
        var getchunk = fileContents.substring(startPosition, endPosition);
        saveContentVersion(file.name, encodeURIComponent(getchunk), attachId, async (result) => {
            attachId = result;
            startPosition = endPosition;
            endPosition = Math.min(fileContents.length, startPosition + CHUNK_SIZE);
            if (startPosition < endPosition) {
                return uploadInChunk(file, fileContents, startPosition, endPosition, attachId, recordId, callback);
            }else{
                callback(attachId);
            }
        }, recordId);        
    }
    
    function getHeading(){
        const { verifiedEntity, Id, account } = state;
        let heading = '';
        if(account !== null){
            heading = "You will be creating this case as "+account.name+" with Microsoft Id: "+account.localAccountId;
            if(Id !== null && Id.length > 0){
                heading = "You will be modifying this case as "+account.name+" with Microsoft Id: "+account.localAccountId;
            }
        }else{
            heading = "You will be creating this case as "+verifiedEntity.name+" with Id: "+verifiedEntity.sub;
            if(Id !== null && Id.length > 0){
                heading = "You will be modifying this case as "+verifiedEntity.name+" with Id: "+Id;
            }
        }
        if(config !== null && config.debug === true){
            return heading;
        }
        if(Id !== null && Id.length > 0){
            return "View Case";
        }
        return "Create Case";
    }
    async function onAddComment(){
        const { Id, Comment, loading } = state;
        if(loading || (!Comment || Comment.length <= 0)){
            return;
        }
        const requestData = {
            CommentBody: Comment,
        };
        let headers = {};
        let method = 'POST';
        let route = '/v1/servicedesk/sfcase/'+Id+'/casecomment';

        const object: Case = {
            sObjectTypeName: "CaseComment",
            url: route,
            method: method,
            headers: headers,
            data: requestData
        };

        callApi(dataProvider, object).then((response: any) => {
            let result = response.result;
            if(Array.isArray(result)){
                result = result[0];
            }
            console.log("Comment", result);
            const items = [result].concat(state.items);
            setState({
                savingComment: false,
                items: items,
                Comment: ""
            });
        }).catch((err) => {
            console.log(err);
        });

        setState({
            savingComment: true,
        });
    }
    function renderComments(){
        const { loadingItems, items } = state;
        if(loadingItems || !Array.isArray(items) || items.length <= 0){
            return;
        }
        if(state.error && state.errorMessage !== null){
            return;
        }
        return (
            <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                {
                    items.map(comment => {
                        let name = (comment.commenterFirstName+" "+comment.commenterLastName);
                        if(comment.commenterAlternativeName && comment.commenterAlternativeName.length > 0){
                            name = comment.commenterAlternativeName;
                        }
                        return (
                            <MDBox key={comment.Id} component="li" display="flex" alignItems="center" py={1} mb={1}>
                                <MDBox mr={2}>
                                    <MDAvatar name={name} shadow="md" />
                                </MDBox>
                                <MDBox display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
                                    <MDTypography variant="button" fontWeight="medium">
                                        {name} .<MDTimestamp datetime={comment.createdDate}/>
                                    </MDTypography>
                                    <MDTypography variant="caption" color="text">
                                        {comment.commentBody}
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        )
                    })
                }
            </MDBox>
        )
    }
    async function onCloseCase(){
        const { Id, loading } = state;
        if(loading){
            return;
        }
        const requestData = {};
        let headers = {};
        let method = 'PATCH';
        let route = '/v1/servicedesk/sfcase/'+Id;
        if(state.item.IsClosed){
            requestData['Status'] = 'New';
            // requestData['IsClosed'] = false;
        }else{
            requestData['Status'] = 'Closed';
            // requestData['IsClosed'] = true;
        }

        const object: Case = {
            sObjectTypeName: "Case",
            url: route,
            method: method,
            headers: headers,
            data: requestData
        };

        callApi(dataProvider, object).then((response: any) => {
            let result = response.result;
            if(Array.isArray(result)){
                result = result[0];
            }
            setState({
                loading: false,
                ...result,
                item: result
            });
        }).catch((err) => {
            setState({
                loading: false,
                closeModal: false
            });
        });

        setState({
            loading: true,
            closeModal: false
        });
    }
    function onConfirmationModal(status = false){
        setState({
            closeModal: status
        });
    }

    return (
        <MDModal
            open={props.open}
            footer={
                (
                    state.error && state.errorMessage !== null ?
                        <Stack p={2}>
                            <Alert severity="error">{state.errorMessage}</Alert>
                        </Stack>
                    :
                        null
                )
            }
            onClose={() => props.onCancel(state.item)}
            title={getHeading()}
            width="700px"
            maxWidth="700px"
        >
            <div className="slds-p-around_medium">
                {
                    loadingForm ?
                        <Loader color="info" />
                    :
                    <FormWizard
                        formBuilder={false}
                        formType={state.formType}
                        currentFormTab={state.currentFormTab}
                        form={state.form}
                        data={state}
                        item={state.item}
                        onFormChange={(form) => setState({form: form})}
                        onSuccess={(data, files) => onSuccess(data, files)}
                        onCancel={() => props.onCancel(state.item)}
                        saving={state.loading}
                        uploadingFiles={state.uploadingFiles}
                        disabled={(state.Id.length > 0)}
                        savingText={(
                            state.Id.length <= 0 ?
                                state.uploadingFiles ?
                                    "Please wait while your files are securely uploaded...."
                                :
                                state.loading ?
                                        "Please wait while your case is securely created..."
                                    :
                                        null
                            :
                                null
                        )}
                        buttons={(
                            <>
                                
                                {
                                    user !== null && user.superAdmin ?
                                        state.Id.length > 0 ?
                                            state.IsClosed ?
                                            <MDButton key="openCase" variant="gradient" color="error" onClick={() => onConfirmationModal(true)} >
                                                Reopen Case
                                            </MDButton>
                                            :
                                            <MDButton key="closeCase" variant="gradient" color="error" onClick={() => onConfirmationModal(true)} >
                                                Close this Case
                                            </MDButton>
                                        :
                                        null
                                    :
                                        null
                                }
                            </>
                        )}
                    />
                }
                {
                    state.IsClosed === false && state.Id.length > 0 && state.loadingItems === false && state.errorMessage === null ?
                        <>
                            <MDBox mb={2} pt={2}>
                                <MDInput
                                    label="Enter Comment"
                                    fullWidth
                                    onChange={(event) => handleChange(event, "Comment")}
                                    value={state.Comment}
                                />
                            </MDBox>

                            <MDBox mb={2}>
                                <MDButton variant="gradient" color="info" disabled={state.IsClosed} onClick={onAddComment}>
                                    {
                                        state.savingComment ?
                                            <Loader color="white" size={20} />
                                        :
                                            "Add Comment"
                                    }
                                </MDButton>
                            </MDBox>
                        </>
                    :
                    null
                }
                {
                    state.loadingItems === false && state.loadingFieldSet === false ?
                        renderComments()
                    :
                        null
                }
                {
                    state.closeModal ?
                        <Confirmation
                            open={state.closeModal}
                            item={state.item}
                            onCancel={() => onConfirmationModal(false)}
                            onSuccess={onCloseCase}
                            message={(
                                state.item.IsClosed ?
                                    "Are you sure you want to open this case?"
                                :
                                    "Are you sure you want to close this case?"
                            )}
                            saving={state.saving}
                            errorMessage={state.errorMessage}
                        />
                    :
                    null
                }
            </div>
        </MDModal>
    )
};

CaseModal.defaultProps = {
    item: null
}
CaseModal.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    onDelete: PropTypes.func,
    open: PropTypes.bool,
    item: PropTypes.object,
    verifiedEntity: PropTypes.object,
    basename: PropTypes.string,
    saving: PropTypes.bool
};

export default CaseModal;